module.exports = __webpack_public_path__ + "static/media/benefits7.ad7dee55.png";